import React from 'react';
import * as ST from './styled';

export const TrackContent = ({ slide = {} }) => {
    return (
        <ST.StyledLink href={slide.href} rel='nofollow noopener noreferrer'>
            <ST.Image  src={slide.src} alt={slide.alt} width='766' height='332' />
        </ST.StyledLink>
    );
};
